// Contact / Visit Us content. Contact details are real (from worldfarmers.org);
// hours and the demo email are placeholder for the design preview.
import { ORG } from "@/content/worldFarmers";

export const CONTACT_INTRO = {
  eyebrow: "",
  title: "Contact Us",
  lede:
    "Questions about buying crops, supporting a farmer, or joining the community? Reach out \u2014 we would love to hear from you.",
  heroImage: "/images/wf/farm-36.jpg",
  heroAlt: "A smiling farmer in a plaid shirt and sun hat standing in a bright field of greens.",
};

export const CONTACT_INFO = {
  phone: ORG.phone,
  phoneHref: ORG.phoneHref,
  email: "info@worldfarmers.org",
  emailHref: "mailto:info@worldfarmers.org",
  officeLabel: "World Farmers Office",
  // Visit address shown without the PO box.
  addressLines: ["769 Main St.", "Lancaster, MA 01523"],
  // Full mailing address (with box) shown separately at the bottom of Visit us.
  mailingLines: ["769 Main St. Box 112", "Lancaster, MA 01523"],
  mapQuery: "769 Main St, Lancaster, MA 01523",
};

export const CONTACT_HOURS = [
  { label: "Office", value: "Mon \u2013 Fri, 9:00 AM \u2013 5:00 PM" },
  { label: "Farm visits", value: "By appointment" },
];

export const CONTACT_SUBJECTS = [
  "General inquiry",
  "Wholesale Purchasing",
  "CSA or Farmers\u2019 Markets",
  "Donating or Sponsoring",
  "Media",
  "Community Partnerships",
];
